import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

interface ReasonConfirmDialogData {
	header?: string;
	label?: string;
	confirmLabel?: string;
	message?: string;
}

@Component({
	selector: 'app-reason-confirm-dialog',
	templateUrl: './reason-confirm-dialog.component.html',
	styleUrls: ['./reason-confirm-dialog.component.scss']
})
export class ReasonConfirmDialogComponent implements OnInit {
	static readonly MAX_LENGTH = 250;

	form!: FormGroup;
	label = 'Reason';
	confirmLabel = 'Confirm';
	message?: string;
	maxLength = ReasonConfirmDialogComponent.MAX_LENGTH;

	constructor(
		private fb: FormBuilder,
		private ref: DynamicDialogRef,
		private config: DynamicDialogConfig
	) {}

	ngOnInit(): void {
		const data: ReasonConfirmDialogData = this.config.data ?? {};
		this.label = data.label ?? this.label;
		this.confirmLabel = data.confirmLabel ?? this.confirmLabel;
		this.message = data.message;

		this.form = this.fb.group({
			reason: ['', [Validators.required, Validators.maxLength(this.maxLength)]]
		});
	}

	get isInvalid(): boolean {
		const value = (this.form.get('reason')?.value ?? '').trim();
		return value.length === 0 || this.form.invalid;
	}

	onCancel(): void {
		this.ref.close();
	}

	onConfirm(): void {
		const reason = (this.form.get('reason')?.value ?? '').trim();
		if (!reason) {
			this.form.markAllAsTouched();
			return;
		}
		this.ref.close(reason);
	}
}
